module.exports = __webpack_public_path__ + "static/curtain-mobile-77655182e194de12b8f78ecaac9f08a4.mp4";